module.exports = __webpack_public_path__ + "img/03_WALZE_Image_2-16362.f9504e3c.jpg";